module.exports = __webpack_public_path__ + "img/day-21.8d92b871.png";